//= require_tree .

// ref : http://stackoverflow.com/questions/7203304/warning-cant-verify-csrf-token-authenticity-rails
$.ajaxSetup({
  headers: {
  'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
  }
});